import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./AboutVDNI.css";

const AboutVDNI = () => {
  return (
    <section className="vdni-section">
      <Container>
        <Row className="align-items-center">
          {/* Left side: text content */}
          <Col lg={6} md={12} className="vdni-content">
            <h1 className="vdni-title">VDNI</h1>
            <p className="vdni-text">
              VDNI is a young, energetic, and enterprising digital services company whose motto is to inspire, entertain, and create a positive impact on driving business growth in terms of more traffic, more visibility, more engagements, and more leads.
            </p>
            <p className="vdni-text">
              Our services include music and video distribution, digital marketing, celebrity account management, brand management, website & application development, and design solutions.
            </p>
            <p className="vdni-text">
              VDNI has partnered with Google, YouTube, AdSense, and AdWords for over a decade. Our global collaborations and timely project completions make us a leading digital distribution and content monetization company.
            </p>
            <Link to="/services" className="vdni-btn">
              Explore Services
            </Link>
          </Col>

          {/* Right side: image */}
          <Col lg={6} md={12} className="vdni-image">
            <img src='/Images/about-vdni.avif' alt="VDNI" />
          </Col>
        </Row>
      </Container>

      {/* Optional Features Section */}
      <div className="vdni-features">
        <Container>
          <Row className="feature-cardRow">
            <Col className="feature-card">
              <h3>Digital Marketing</h3>
              <p>Boost brand awareness and reach audiences worldwide efficiently.</p>
            </Col>
            <Col className="feature-card">
              <h3>Content Distribution</h3>
              <p>Music & video content distributed across multiple platforms.</p>
            </Col>
            <Col className="feature-card">
              <h3>Celebrity & Brand Management</h3>
              <p>Manage profiles, enhance visibility, and increase engagement.</p>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default AboutVDNI;
